module.exports = __webpack_public_path__ + "static/media/1POLICY47.7ddad037.jpg";